module.exports = "<!-- Application Top Menu -->\n<top-menu></top-menu>\n<!-- Application Main Menu -->\n<main-menu [module]=\"module\"></main-menu>\n<!-- Process bar -->\n<!--<process-bar></process-bar>-->\n<!-- Application Content -->\n<router-outlet></router-outlet>\n<!-- Application Footer -->\n<footer></footer>\n<!-- Application Inspired -->\n<inspired></inspired>";


//////////////////
// WEBPACK FOOTER
// ./src/services/AppComponent.html
// module id = 644
// module chunks = 0